import { AssetBucketUrlPrefix } from '../../../utils/Constants';

export const heroText = {
  imageList: [
    {
      id: 0,
      imgSrc: `${AssetBucketUrlPrefix}/hero/teamLabsSmoke.webp`,
      alt: 'Image of myself in a plume of red smoke',
      position: {
        x: 0,
        y: 0,
      },
    },
    {
      id: 1,
      imgSrc: `${AssetBucketUrlPrefix}/lines-of-code-images/drowsinessDetection.webp`,
      alt: 'Image of a female with red dots tracking her face and blue squares surrounding her eyes',
      position: {
        x: 0,
        y: 0,
      },
    },

    {
      id: 2,
      imgSrc: `${AssetBucketUrlPrefix}/hero/mouse.webp`,
      alt: 'Image of a mouse',
      position: {
        x: 0,
        y: 0,
      },
    },
    {
      id: 3,
      imgSrc: `${AssetBucketUrlPrefix}/hero/teamLabsBlue.webp`,
      alt: 'Image of myself in a blue sky',
      position: {
        x: 0,
        y: 0,
      },
    },
    {
      id: 4,
      imgSrc: `${AssetBucketUrlPrefix}/lines-of-code-images/characterRecognition.webp`,
      alt: 'Image of the character 7 four times in a box formation',
      position: {
        x: 0,
        y: 0,
      },
    },
    {
      id: 5,
      imgSrc: `${AssetBucketUrlPrefix}/hero/quarantine.webp`,
      alt: 'Image of an app with plants and a list of food options',
      position: {
        x: 0,
        y: 0,
      },
    },
    {
      id: 6,
      imgSrc: `${AssetBucketUrlPrefix}/lines-of-code-images/projectWindExperience.webp`,
      alt: 'Image of a website with a samurai sitting in the middle',
      position: {
        x: 0,
        y: 0,
      },
    },
  ],
  title: 'A.',
  personalStatement: "HI I'M ASHAN. I BUILD FULLSTACK APPLICATIONS THAT RUN ON AWS CLOUD.",
};
